import { Col, Container, Row } from 'react-bootstrap';
import LoginBar from './LoginBar';
import CartBar from './CartBar';
import { FormattedMessage } from 'react-intl';
import { useSiteConfig } from 'contexts/SiteConfigProvider';
import ContactUsIcon from './ContactUsIcon';

function ApTopBar() {
  const { getCountryUrl } = useSiteConfig(),
    countryUrl = getCountryUrl();

  return (
    <Container fluid className="ap-top-bar">
      <div className="main-container">
        <Row>
          <Col className="d-none d-sm-none d-md-block">
            <a id="osvc_reg_contactus" href={countryUrl.contactUs} className="me-4" rel="noreferrer">
              <FormattedMessage id="ml_114704" defaultMessage="X - Contact Us" />
            </a>
          </Col>
          <Col xs="auto" sm="auto" className="d-block d-sm-block d-md-none">
            <a id="osvc_reg_contactus" href={countryUrl.contactUs} className="me-4" rel="noreferrer">
              <ContactUsIcon width={16} height={16}></ContactUsIcon>
            </a>
          </Col>
          <Col>
            <Row className="float-end">
              <Col className="col-auto ps-0 pe-3"><a href={countryUrl.aboutUs} target="_blank" rel="noreferrer"><FormattedMessage id="ml_114719" defaultMessage="X - About Us" /></a></Col>
              <Col className="col-auto ps-0 pe-3"><div className="line-separator"></div></Col>
              <Col className="col-auto ps-0 pe-3"><LoginBar></LoginBar></Col>
              <Col className="col-auto ps-0 pe-3"><div className="line-separator"></div></Col>
              <Col className="ps-0"><CartBar></CartBar></Col>
            </Row>
          </Col>
        </Row>
      </div>
    </Container>
  );
}

export default ApTopBar;